/* eslint-disable react-hooks/exhaustive-deps */
import { Row, Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { PlusOutlined } from '@ant-design/icons'
import React, { useState, useEffect } from 'react'
import { showNotification } from 'src/core/helpers'
import styles from './FootPrintListHeader.module.scss'
import FootPrintForm from '../FootPrintForm/FootPrintForm'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomModal, CustomTitle, CustomCol } from 'src/components'
import { createFootPrint, createFootprintSelector, resetFootPrintCreateState } from 'src/features'

const FootPrintListHeader: React.FC = () => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const dispatch = useAppDispatch()

  const { success, loading } = useAppSelector(createFootprintSelector)

  const handleSubmit = (values: any) => {
    dispatch(createFootPrint(values))
  }

  useEffect(() => {
    if (success) {
      setIsModalVisible(false)
      showNotification('success', t('general.OperationSuccess'))
      dispatch(resetFootPrintCreateState())
    }
  }, [success])

  return <div className={styles['header-margin']}>
    <Row>
      <CustomCol xs={12}>
        <CustomTitle label={t('menuItems.FootPrint')}/>
      </CustomCol>
      <CustomCol xs={12}>
        <Button
          type='primary'
          icon={<PlusOutlined />}
          onClick={() => setIsModalVisible(true)}
          className={styles.button}
        >{t('footPrint.AddRegister')}
        </Button>
      </CustomCol>
    </Row>

    <CustomModal
      footer={null}
      title={<CustomTitle label={t('footPrint.AddRegister')}/>}
      onCancel={() => setIsModalVisible(false)}
      open={isModalVisible}
    >
      <FootPrintForm handleSubmit={handleSubmit} isLoading={loading} />
    </CustomModal>
  </ div>
}

export default FootPrintListHeader
